/*
 *
 *  * Copyright (c) Funtip GbR 2018.
 *  * Simon Oldeboershuis, Perry Prust
 *
 */

import moment from 'moment';
import * as React from 'react';
import { Button } from 'reactstrap';
import { Job } from '../../../services/playlist';

interface JobProps {
    job: Job;
    onDelete: (id: string, group: string) => void;
}

export const JobComponent: React.FC<JobProps> = (props) => {
    const trimPackageName = (jobName: string) => {
        const index = jobName.lastIndexOf('.');
        if (index !== -1) {
            return jobName.substring(index + 1);
        } else {
            return jobName;
        }
    };
    const onDelete = () => {
        props.onDelete(props.job.triggerName, props.job.triggerGroup);
    };

    if (!props.job) {
        return null;
    }
    return (
        <tr>
            <td className="text-break">{trimPackageName(props.job.jobName)}</td>
            <td className="d-none d-lg-table-cell">{props.job.jobDescription}</td>
            <td>{props.job.triggerState}</td>
            <td className="d-none d-lg-table-cell">{moment(props.job.nextFireTime).format('YYYY-MM-DD HH:mm:ss')}</td>
            <td className="d-none d-lg-table-cell">{props.job.cronExpression}</td>
            <td>
                <Button color="danger" onClick={onDelete}>
                    Delete
                </Button>
            </td>
        </tr>
    );
};
